module.exports = __webpack_public_path__ + "dfbb8ece3ea71eda065c5e2ccada60e8.jpg";